import classnames from 'classnames';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';

import styles from './Submenu.module.scss';

const Submenu = ({
  className,
  children,
  enabled,
  iconType: IconComponent,
  isHover,
  label,
  refHandler,

  onClick,
  onHover = noop,
  onLeave = noop,
}) => {
  if (!enabled) {
    return null;
  }

  return (
    <div
      ref={refHandler}
      onClick={onClick}
      onMouseEnter={onHover}
      onMouseLeave={onLeave}
      className={classnames(styles.submenu, 'action-button__icon', className, {
        [styles.hover]: isHover,
        [styles.noIcon]: IconComponent == null,
      })}
    >
      {IconComponent != null && <IconComponent className={styles.icon} />}

      <span className={styles.title}>{label}</span>

      {IconComponent != null && (
        <div className="expand">
          <div className="align y">
            <div>
              <span className="sprite item-group-expand"></span>
            </div>
          </div>
        </div>
      )}

      {children}
    </div>
  );
};

Submenu.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  enabled: PropTypes.bool,
  iconType: PropTypes.elementType,
  isHover: PropTypes.bool,
  label: PropTypes.string.isRequired,
  refHandler: PropTypes.func,

  onClick: PropTypes.func,
  onHover: PropTypes.func,
  onLeave: PropTypes.func,
};

export default Submenu;
